export const { REACT_APP_API_VERSION } = process.env;

export const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

export const REACT_APP_GEO_API_KEY = `${process.env.REACT_APP_GEO_API_KEY}`;
